export default __webpack_public_path__ + "static/media/Chalten40.b17c3997.jpg";